import type { HTMLAttributes, ReactNode, CSSProperties } from 'react';
import './Panel.css';

export interface PanelProps extends Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title?: ReactNode;
  meta?: ReactNode;
  actions?: ReactNode;
  active?: boolean;
  flush?: boolean;
  padded?: boolean;
  bodyStyle?: CSSProperties;
  children?: ReactNode;
}

export function Panel({
  title,
  meta,
  actions,
  children,
  active = false,
  flush = false,
  padded = true,
  style,
  bodyStyle,
  ...rest
}: PanelProps) {
  return (
    <section
      className={`uc-panel${flush ? ' uc-panel--flush' : ''}${active ? ' uc-panel--active' : ''}`}
      style={style}
      {...rest}
    >
      {(title || actions || meta) && (
        <header className="uc-panel__head">
          {title && <h3 className="uc-panel__title">{title}</h3>}
          {meta && <span className="uc-panel__meta">{meta}</span>}
          {actions && <div className="uc-panel__actions">{actions}</div>}
        </header>
      )}
      <div
        className={`uc-panel__body uc-scroll${padded ? '' : ' uc-panel__body--flush'}`}
        style={bodyStyle}
      >
        {children}
      </div>
    </section>
  );
}
